import { render } from "./CreateOrganisationGroup.vue?vue&type=template&id=2f483292"
import script from "./CreateOrganisationGroup.vue?vue&type=script&lang=js"
export * from "./CreateOrganisationGroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__